import React from "react";
import { MessageBar, MessageBarType } from "office-ui-fabric-react";
import { AlertDialog } from "../../../../common/AlertDialog";
import { guardListStyle } from "./common";

interface Props {
    messages: string[];
    onDismiss: () => void;
}

const ApplyResultDialog = (props: Props) => (
    <AlertDialog onDismiss={props.onDismiss} dialogContentProps={{ title: "Some requests could not be moved" }}>
        <MessageBar messageBarType={MessageBarType.warning} isMultiline>
            {props.messages.length === 1 ? (
                props.messages[0]
            ) : (
                <ul style={guardListStyle}>
                    {props.messages.map(message => (
                        <li key={message}>{message}</li>
                    ))}
                </ul>
            )}
        </MessageBar>
    </AlertDialog>
);

export default ApplyResultDialog;
